import * as React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { syncCoverWithProfile } from '../../../actions/selfInspectActions';
import { AGREED_VALUE_COVER_TYPE, CHILLI_CAR_COVER_TYPE, COMPREHENSIVE_CAR_COVER_TYPE, THEFT_WRITEOFF_CAR_COVER_TYPE, THIRDPARTY_CAR_COVER_TYPE, THIRDPARTY_FIRETHEFT_CAR_COVER_TYPE } from '../../../constants/constants';
import { DASHBOARD, PERSONAL_INSURANCE } from '../../../routes/routes';
import KPBreadCrumb from '../../KPBreadCrumb/KPBreadCrumb';
import '../PolicyDetails/PolicyDetails.css';

class QuotedItemDetail extends React.Component<any, any> {
    constructor(props) {
        super(props);
        this.state = {
            reminderDismissed: false
        };
        this.handleSelfInspectionRequired = this.handleSelfInspectionRequired.bind(this);
    }

    async handleSelfInspectionRequired() {
        await this.props.dispatchAction(syncCoverWithProfile());
    }

    public render() {
        const isMobile = window.innerWidth <= 975;
        const profile = this.props.profile;
        const cover = profile.selectedPersonalQuotedCover;
        const mainCoverItem = cover.quoteCovers.filter(x => x.product.productType === 1)[0]    //Get mainline item
        const inspectionRequired = (profile.inspectionItems.filter(x => x.riskItemID === cover.quoteRiskItem.quoteRiskItemLinkingId).length > 0);

        let BreadcrumbDetails = [{ destination: DASHBOARD, description: "Home" }, { destination: PERSONAL_INSURANCE, description: "Personal insurance" }];

        let coverStartDate = (mainCoverItem.inceptionDate?.toString().trim().length >= 10) ? mainCoverItem.inceptionDate.substring(0, 10) : "";

        let coverType = mainCoverItem.name;

        switch (mainCoverItem.productId.toUpperCase()) {
            case THEFT_WRITEOFF_CAR_COVER_TYPE: { coverType = "Motor theft and write off"; break; }
            case THIRDPARTY_CAR_COVER_TYPE: { coverType = "Third party"; break; }
            case THIRDPARTY_FIRETHEFT_CAR_COVER_TYPE: { coverType = "Third party fire and theft"; break; }
            case COMPREHENSIVE_CAR_COVER_TYPE: { coverType = "Comprehensive cover on retail value"; break; }
            case AGREED_VALUE_COVER_TYPE: { coverType = "Comprehensive cover on agreed value"; break; }
            case CHILLI_CAR_COVER_TYPE: { coverType = "Chilli"; break; }
        }

        if (cover) {
            return (
                <>
                    {isMobile &&
                        <KPBreadCrumb navList={BreadcrumbDetails} activePage="Car" />
                    }
                    <div className="box mb-3">
                        <div className="card">
                            {(!this.state.reminderDismissed && inspectionRequired) &&
                                <div className="Reminder-banner banner-padding mb-3">
                                    <div className="cursor-pointer row noma" onClick={this.handleSelfInspectionRequired}>
                                        <div className="nopa mr-15px">
                                            <img src="Images/White.svg" className="warning-icon-car" />
                                        </div>
                                        <div className="col-10 nopa">
                                            <p className="Monthly-mileage-update-car mb-0px">Self-inspection required. <Link onClick={this.handleSelfInspectionRequired} id="SubmitMonthlyMileageBannerLink" className="Link-monthly-mileage-reminder-car">Tap here.</Link> </p>
                                        </div>
                                    </div>
                                    <div onClick={() => this.setState({ reminderDismissed: true })}>
                                        <img className="Reminder-banner-close-img-car" src="Images/icons-navigation-close-16-px-white.svg" alt="Dismiss" />
                                    </div>
                                </div>
                            }
                        </div>

                        <div id="Policy-details-car" className={(!this.state.reminderDismissed && inspectionRequired) ? "pt-0" : ""}>
                            <div className="row noma nopa">

                                <div className="col-lg-8 col-md-8 col-12 nopa">
                                    <p className="font-size-22px font-weight-bold line-height-normal mb-10px">{cover.quoteRiskItem.description}</p>
                                    <div>
                                        <p className="font-weight-normal line-height-normal mb-3px">{coverType}</p>
                                        <p className="coverAmount mb-3">{profile.currencySymbol}{cover.grossPremium}pm</p>
                                        {coverStartDate.length > 0 &&
                                            <div>
                                                <p className="font-weight-normal line-height-normal mb-0">Cover start date</p>
                                                <p className="font-size-16px font-weight-bold line-height-normal mb-0">{coverStartDate}</p>
                                            </div>
                                        }
                                    </div>
                                </div>

                                <div className="col-lg-4 col-md-4 col-12 nopa text-lg-right text-center">
                                    <div className="bling-update-polic-button-holder">
                                        {inspectionRequired &&
                                            <div className="mt-10px">
                                                <button className="self-inspection-button btn" onClick={this.handleSelfInspectionRequired}>Self-inspection required</button>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                            </div>
                    </div>
                </>
            );
        }
        else return (
            <></>
        );
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        router: state.router,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchAction: (e) => dispatch(e)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(QuotedItemDetail);